export default "/institutions/ifood.svg";